import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';

import en from './locales/en/translation.json';
import ru from './locales/ru/translation.json';
import cn from './locales/cn/translation.json';

i18n
  .use(I18nextProvider)
  .init({
    fallbackLng: 'ru',
    debug: true,
    ns: ['common', 'translation'],
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false
    },

    resources: {
      en: { translation: en },
      ru: { translation: ru , common: ru },
      cn: { translation: cn }
    },

    react: {
      defaultTransParent: 'span',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false
    }
  });

export default i18n;
